'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _d3Shape = require('d3-shape');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var radius = 45;

var AnimatedDonut = function (_PureComponent) {
  _inherits(AnimatedDonut, _PureComponent);

  function AnimatedDonut() {
    _classCallCheck(this, AnimatedDonut);

    return _possibleConstructorReturn(this, (AnimatedDonut.__proto__ || Object.getPrototypeOf(AnimatedDonut)).apply(this, arguments));
  }

  _createClass(AnimatedDonut, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var sum = this.props.data.reduce(function (a, b, i) {
        return a + b.value;
      }, 0);

      this.setState({
        pathLengths: this.props.data.map(function (_ref) {
          var value = _ref.value;
          return {
            current: value / sum * radius * Math.PI * 2 * 2,
            end: value / sum * radius * Math.PI * 2
          };
        })
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          speed = _props.speed,
          width = _props.width;


      var arcs = (0, _d3Shape.pie)().value(function (d) {
        return d.value;
      }).sort(function (_) {
        return undefined;
      })(data);
      var drawArc = (0, _d3Shape.arc)().outerRadius(radius).innerRadius(radius);
      var pathLengths = this.state.pathLengths;
      var children = this.props.children;


      if (pathLengths.every(function (offset) {
        return offset.current <= offset.end;
      })) {
        clearInterval(this.interval);
      }

      window.requestAnimationFrame(function () {
        _this2.setState(function (_ref2) {
          var pathLengths = _ref2.pathLengths;
          return pathLengths.some(function (offset) {
            return offset.current > offset.end;
          }) ? {
            pathLengths: pathLengths.map(function (offset, i) {
              return offset.current > offset.end && (i === 0 || pathLengths[i - 1].current <= pathLengths[i - 1].end) ? Object.assign({}, offset, {
                current: offset.current - speed
              }) : offset;
            })
          } : _this2.state;
        });
      });

      return _react2.default.createElement(
        'svg',
        { viewBox: '0 0 100 100' },
        _react2.default.createElement(
          'g',
          { transform: 'translate(50, 50)' },
          arcs.map(function (arc, i) {
            return _react2.default.createElement('path', {
              key: i,
              d: drawArc(arc),
              style: {
                stroke: arc.data.color,
                strokeWidth: width,
                strokeDasharray: pathLengths[i].end * 2,
                strokeDashoffset: pathLengths[i].current
              }
            });
          }),
          children
        )
      );
    }
  }]);

  return AnimatedDonut;
}(_react.PureComponent);

AnimatedDonut.defaultProps = {
  data: [{ value: 50, color: '#ED696C' }, { value: 10, color: '#f0e387' }, { value: 30, color: '#d6d6d6' }, { value: 70, color: '#43b4a1' }],
  speed: 5,
  width: 5
};

exports.default = AnimatedDonut;
